import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { message } from "../../redux/actions/toastActions";
import { Topbar } from "../../components/include/Topbar";
import Loader from "../../components/common/Loader";
import { isPermission, isRole, isRoleType } from "../../redux/selectors/authSelector";
import Error403Page from "../ErrorPage";
import { toast } from "sonner";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";

const Add_project = () => {
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const fileInputRef = useRef();
  const [selectedFile, setSelectedFile] = useState(null);
  const [deletedFiles, setDeletedFiles] = useState([]);
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);
  const mode = localStorage.getItem("mode");
  const { id } = useParams();
  console.log("permissions", permissions);
  const isAccessible =
    role === "admin" ||
    role === "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("edit_Education") || permissions?.includes("edit_School"))) ||
    false;
  const schoolId = localStorage.getItem("activeSchoolId");
  const [formData, setFormData] = useState({
    title: "",
    people_involved: 1,
    image: [],
    description: "",
  });

  const validate = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Project title is required";
    if (!formData.people_involved)
      newErrors.people_involved = "Number of people is required";
    if (!formData.description)
      newErrors.description = "Description is required";
    if (!selectedFile || selectedFile.length === 0) {
      newErrors.image = "At least one image is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoader(true);

    const form = new FormData();
    if (params.id) form.append("id", params.id);
    form.append("title", formData.title);
    form.append("people_involved", formData.people_involved);
    form.append("image", formData.image);
    form.append("description", formData.description);
    form.append("school_id", schoolId);
    if (selectedFile?.length) {
      selectedFile.forEach((file) => {
        form.append("image", file);
      });
    }
    if (deletedFiles?.length) {
      deletedFiles.forEach((file) => {
        form.append("deletedFiles[]", file);
      });
    }

    Postdata(HttpService.project_add, form).then((res) => {
      if (res.status === 200) {
        toast.success(res.message);
        if (role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin") {
          if (mode === "view") {
            navigate(`admin-school/view/${schoolId}`, {
              state: { mainTab: "Education", currentTab: "Projects" },
            });
          } else {
            navigate("navigation-dashboard", {
              replace: true,
              state: { mainTab: "Education", currentTab: "Projects" },
            });
          }
        } else {
          navigate(`education`, {
            replace: true,
            state: { currentTab: "Projects" },
          });
        }
      }
      // dispatch(message(res.message));
      setLoader(false);
    });
    console.log("Submitted as FormData:", formData);
  };

  const fetchData = () => {
    setLoader(true);
    Postdata(HttpService.project_show, {
      id: params.id,
      school_id: schoolId,
    }).then((res) => {
      if (res.status === 200) {
        setFormData({
          title: res.data.title,
          people_involved: res.data.people_involved,
          image: res.data.image,
          description: res.data.description,
        });
        setSelectedFile(res.data.image);
      }
      // else {
      //     dispatch(message(res.message));
      // }
      setLoader(false);
    });
  };

  useEffect(() => {
    if (location.state?.type === "edit") {
      fetchData();
    }
  }, []);

  // if (loader) {
  //     return <Loader isClass="loader_fullscreen" />
  // }

  if (!isAccessible) {
    return <Error403Page />;
  }
  return (
    <>
      <Topbar
        title={location.state?.type == "edit" ? "Edit Project" : "Add Project"}
        aerrow={true}
      />

      <div className="p-6 bg-gray-100 min-h-screen">
        <form onSubmit={(e) => handleSubmit(e)}>
          {/* Inline Inputs */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {/* Performance Year */}
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                Project Title<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="title"
                placeholder="Enter Project Name"
                className="input-field"
                value={formData.title}
                onChange={handleInputChange}
              />
              {errors.title && (
                <span className="text-red-500 text-sm">{errors.title}</span>
              )}
            </div>

            <div className="md:col-span-2">
              <label className="block mb-1 font-medium text-gray-700">
                People Involved<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="people_involved"
                placeholder="Write Here"
                className="input-field"
                value={formData.people_involved}
                onChange={handleInputChange}
                max={100}
                min={1}
              />
              {errors.people_involved && (
                <span className="text-red-500 text-sm">
                  {errors.people_involved}
                </span>
              )}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <div className="">
              <label className="block mb-1 font-medium text-gray-700">
                Project Image<span className="text-red-500">*</span>
              </label>
              <div className="relative flex-1">
                <input
                  type="text"
                  placeholder="Select Image"
                  className="input-field"
                  readOnly
                //   value={pdfFile?.name || ""}
                />
                <button
                  type="button"
                  onClick={() => fileInputRef.current.click()}
                  className="absolute top-1/2 right-3 -translate-y-1/2 text-orange-600 font-semibold"
                >
                  Upload
                </button>
              </div>
              {/* Hidden File Input */}
              <input
                type="file"
                ref={fileInputRef}
                name="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => {
                  const files = Array.from(e.target.files);
                  const maxFiles = 10;
                  const maxSize = 5 * 1024 * 1024; // 10 MB
                  const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

                  let newFiles = [...(selectedFile || [])];
                  let errorMsg = "";

                  for (let file of files) {
                    if (!allowedTypes.includes(file.type)) {
                      // errorMsg = `Only JPG, JPEG, PNG formats are allowed.`;
                      toast.warning(`Only JPG, JPEG, PNG formats are allowed.`);

                      continue;
                    }
                    if (file.size > maxSize) {
                      // errorMsg = `File  is larger than 10MB.`;
                      toast.warning("Image size must not exceed 5MB");
                      continue;
                    }
                    if (newFiles.length >= maxFiles) {
                      // errorMsg = `You can only upload up to ${maxFiles} images.`;
                      toast.warning(
                        `You can only upload up to ${maxFiles} images.`
                      );
                      break;
                    }
                    newFiles.push(file);
                  }

                  if (errorMsg) {
                    dispatch(message(errorMsg)); // toast
                  }

                  setSelectedFile(newFiles);
                  e.target.value = ""; // reset input so same file can be re-selected
                }}
                className="hidden"
              />
              {errors.image && (
                <span className="text-red-500 text-sm">{errors.image}</span>
              )}
            </div>
            <div className="flex gap-[14px] mt-3">
              {console.log("selectedFile", selectedFile)}
              {selectedFile &&
                selectedFile?.map((file, index) => (
                  <div
                    key={index}
                    className="relative  rounded-md flex items-center justify-center"
                  >
                    <img
                      src={
                        typeof file === "string"
                          ? file
                          : URL.createObjectURL(file)
                      }
                      alt="img"
                      className="w-20 h-20"
                    />
                    <button
                      type="button"
                      onClick={() => {
                        if (
                          typeof file === "string" &&
                          file.startsWith("https")
                        ) {
                          const filePath = file.split("cloudfront.net/")[1];
                          console.log("filePath: ", filePath);

                          if (filePath) {
                            setSelectedFile((prev) =>
                              prev.filter((item, i) => i !== index)
                            );
                            setDeletedFiles((prev) => [...prev, filePath]);
                          }
                        } else {
                          setSelectedFile((prev) =>
                            prev.filter((item, i) => i !== index)
                          );
                        }
                      }}
                      className="absolute -top-2 -right-2 bg-black text-white rounded-full w-5 h-5 text-xs flex items-center justify-center hover:bg-gray-800"
                    >
                      ✕
                    </button>
                  </div>
                ))}
            </div>
          </div>
          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Project Description<span className="text-red-500">*</span>
            </label>
            <textarea
              name="description"
              placeholder="Write Here"
              className="input-field"
              value={formData.description}
              onChange={handleInputChange}
            />
            {errors.description && (
              <span className="text-red-500 text-sm">{errors.description}</span>
            )}
          </div>

          <div className="w-full flex justify-center gap-3 mb-2 mt-4">
            <button
              type="submit"
              className="button-field-primary"
              style={{ width: "30%" }}
              disabled={loader}
            >
              {loader
                ? "Please wait..."
                : location.state?.type == "edit"
                  ? "Save"
                  : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Add_project;
